export class ApplicationInfoModel {
  applicationId?: number;
  additionalBorrowerChecked: boolean;
  borrowerId: number;
  coBorrowerId?: number;
  creditRefNo: string;
  equifaxIndicator: boolean;
  experianIndicator: boolean;
  displayOrder?: number;
  fileDataId?: number;
  transUnionIndicator: boolean;

  /**
   * ApplicationInfoModel copy constructor. Copied from NSwag.
   * Needed for Akita updates - can not be removed.
   * @param data
   */
  constructor(data?: ApplicationInfoModel) {
    if (data) {
      for (const property in data) {
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
}
